import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import {
  Button,
  Card,
  Col,
  Form,
  FormControl,
  InputGroup,
  Row
} from 'react-bootstrap';
import ReactSelect from 'react-select';

const ADDonationDetails = () => {
  const [donationType, setDonationType] = useState(null);
  const [donationCurrency, setDonationCurrency] = useState(1);
  const [billingCondition, setBillingCondition] = useState(null);

  const billingConditionsData = [
    { value: '1', label: 'Daily Donation' },
    { value: '2', label: 'Weakly Donation' },
    { value: '3', label: 'Monthly Donation' },
    { value: '4', label: 'Yearly Donation' }
  ];
  const donationTypesData = [
    { value: '1', label: 'Zakat' },
    { value: '2', label: 'ETC' },
    { value: '3', label: 'Others' }
  ];
  const donationCurrencyData = [
    { value: '1', label: 'USD' },
    { value: '2', label: 'PR' },
    { value: '3', label: 'EUR' }
  ];
  return (
    <Card className="mb-3">
      <Card.Header className="pb-0">
        <Card.Title className="fw-medium">
          Donation Details / Allocations
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Row className="g-3">
          <Form.Group as={Col} md={6}>
            <Form.Label>Billing Conditions </Form.Label>
            <ReactSelect
              closeMenuOnSelect={true}
              options={billingConditionsData}
              placeholder="Select"
              classNamePrefix="react-select"
              value={billingCondition}
              onChange={value => setBillingCondition(value)}
            />
            <Form.Control.Feedback type="invalid">
              Required
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md={6}>
            <Form.Label>Donation Type</Form.Label>
            <ReactSelect
              closeMenuOnSelect={true}
              options={donationTypesData}
              placeholder="Select"
              classNamePrefix="react-select"
              value={donationType}
              onChange={value => setDonationType(value)}
            />
            <Form.Control.Feedback type="invalid">
              Required
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md={12}>
            <Form.Label>Fund Available Appeals</Form.Label>
            <InputGroup>
              <InputGroup.Text
                id="basic-addon1"
                className="bg-transparent border-end-0 text-400"
              >
                <FontAwesomeIcon icon={'search'} />
              </InputGroup.Text>
              <FormControl
                className="border-start-0"
                placeholder="Search"
                aria-label="Search"
                aria-describedby="basic-addon1"
              />
            </InputGroup>
          </Form.Group>
          <Form.Group as={Col} md={6} controlId="Amount">
            <Form.Label>Amount</Form.Label>
            <Form.Control required type="number" placeholder="0.00" />
            <Form.Control.Feedback type="invalid">
              Amount required
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md={3}>
            <Form.Label>Currency</Form.Label>
            <ReactSelect
              closeMenuOnSelect={true}
              options={donationCurrencyData}
              placeholder="Select"
              classNamePrefix="react-select"
              value={donationCurrency}
              onChange={value => setDonationCurrency(value)}
            />
            <Form.Control.Feedback type="invalid">
              Required
            </Form.Control.Feedback>
          </Form.Group>
        </Row>
        <Button size="lg" className="fs-0 fs-md-1 w-100 py-3 mt-4">
          ADD DONATION
        </Button>
      </Card.Body>
    </Card>
  );
};

export default ADDonationDetails;
